import useFetch from '../hooks/useFetch'
import { apiWrapper, objectToQueryString } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const fetchAccounts = async (searchVal, implementationsOnly) => {
    return apiWrapper({
      fetch,
      url: `accounts${objectToQueryString({ implementationsOnly, name: searchVal })}`,
      options: {
        method: 'GET'
      }
    });
  }

  return {
    fetchAccounts
  }
}